module.exports = __webpack_public_path__ + "static/media/Campus-Inactive-Dark.43f7cf11.svg";